module.exports = __webpack_public_path__ + "static/media/update.ed0332be.svg";